import { Locale } from '@synergy/models';

export const localeReducer = (state: Locale = Locale.English) => {
    return state;
};
